import { render, staticRenderFns } from "./InfoGraphicsComponent.vue?vue&type=template&id=58998a4a&scoped=true&"
import script from "./InfoGraphicsComponent.vue?vue&type=script&lang=js&"
export * from "./InfoGraphicsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58998a4a",
  null
  
)

export default component.exports